import constants from '../constants/appConstants';
import { authGet } from '../utils/fecth-wrappers';

const URL = `${constants.API.auctions}/auctions-filter`;

export function getAuctions(filters = 'limit=300') {
  const url = filters ? `${URL}?${filters}` : URL;
  return authGet(url).then(({ data }) => data?.result || []);
}
